import { emitTimeRangeSelectorEvent, variablesToURLParams } from '.';

export const updateURLWithGlobals = (globals: any) => {
  const urlParams = new URLSearchParams(window.location.search);
  const globalVariablesChanged =
    globals.globals.variables &&
    Object.keys(globals.globals.variables).some(key => {
      return (
        (globals.globals.variables[key] || urlParams.get(key)) &&
        urlParams.get(key) !== '' + globals.globals.variables[key] // url params are always strings
      );
    });

  if (
    globals.globals.variables &&
    (globals.globals.variables.since != urlParams.get('since') ||
      globals.globals.variables.until != urlParams.get('until'))
  ) {
    // we need to set the TRS time range if we change since/until internally but this emit event is not working at the moment
    emitTimeRangeSelectorEvent(globals.globals.variables.since, globals.globals.variables.until);
  }
  if (globalVariablesChanged) {
    const queryString = variablesToURLParams(globals.globals.variables);
    const newUrl = `${window.location.pathname}?${queryString}`;
    if (!urlParams.get('since')) {
      // replaceState if first pageload with no `since` query param,
      // don't want an additional entry in history stack of url without query params
      window.history.replaceState({ ...window.history.state, as: newUrl, url: newUrl }, '', newUrl);
    } else {
      // maintain history stack
      // https://github.com/vercel/next.js/discussions/18072#discussioncomment-109059
      window.history.pushState({ ...window.history.state, as: newUrl, url: newUrl }, '', newUrl);
    }
  }
};
